import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../config/configApi';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(true);

    const fetchAvatar = async (email) => {
        try {
            const avatarResponse = await api.get(`/api/usuario/avatar/${email}`);            
            
            const byteArray = new Uint8Array(avatarResponse.data.avatar.data);
            const blob = new Blob([byteArray], { type: avatarResponse.data.mime_type });            
            const imageUrl = URL.createObjectURL(blob);

            return imageUrl;
        } catch (err) {
            return null;
        }
    }

    useEffect(() => {
        const checkAuthStatus = async () => {
            try {
                const res = await api.get('/api/auth/isUserAuth');
                if (res.data.auth) {
                    const { auth, ...userData } = res.data;
                    if (userData.email) {
                        const avatar = await fetchAvatar(userData.email);
                        setUser({ ...userData, avatar });
                    }
                } else {
                    setUser(null);
                }
            } catch (err) {
                setUser(null);
            } finally {
                setLoadingAuth(false);
            }
        };

        checkAuthStatus();
    }, []);

    const login = async (userData) => {            
        let avatar = null;
        if (userData.email) {
            avatar = await fetchAvatar(userData.email);
        }
        setUser({ ...userData, avatar });
    };        

    const updateUser = (newUserData) => {
        setUser(prevUser => ({
            ...prevUser,
            ...newUserData
        }));
    }

    const logout = async () => {
        setUser(null);
        try {
            const res = await api.get('/api/auth/logout');
            return res;
        } catch (err) {
            throw err;
        }
    };    

    return (
        <AuthContext.Provider value={{ user, loadingAuth, login, updateUser, logout }}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext);
